import { createContext, useContext, useEffect, useState } from 'react';
import { onAdminAuthStateChanged } from '../firebase/auth';

/**
 * Holds resolved admin auth state at the route-layout level so every admin
 * page reads from context instead of each triggering its own Firestore lookup.
 *
 * State:
 *   loading   true  → auth not yet resolved (show spinner, not blank)
 *   adminUser null  → resolved, not signed in (redirect to login)
 *   adminUser obj   → resolved, signed in
 */
const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [adminUser, setAdminUser] = useState(null);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    return onAdminAuthStateChanged(user => {
      setAdminUser(user);
      setLoading(false);
    });
  }, []);

  return (
    <AdminAuthContext.Provider value={{ adminUser, loading }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

/** Hook for admin pages to read resolved auth state — no Firestore call. */
export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
